export const COLORS = {
	DEFAULT_BACKGROUND: '#F3F5F4',
	DEFAULT_TEXT: '#000000',
	MEDIUM_GREY: '#7A7A7C',
	LIGHT_GREY: '#DADADA',
	DECORATIVE_MEDIUM_BLUE: '#5664FF',
	DECORATIVE_LIGHT_BLUE: '#808AFF',
	DECORATIVE_PALE_BLUE: '#B0C6EB',
	DECORATIVE_TRANSPARENT_BLUE: '#D7E6FD',
	DECORATIVE_MEDIUM_PURPLE: '#7F86D3',
	DECORATIVE_LIGHT_PURPLE: '#DBC1FE',
	DECORATIVE_AZURE: '#E4ECFF',
	DECORATIVE_YELLOW: '#DCF831',
	ACCENT_PURPLE: '#7F86D3',
	DECORATIVE_PINK: "#C9ACEF"
}
